import React from 'react';
import { observer } from 'mobx-react';
import { defaultTemplate } from 'core/hoc';
import { Loader, BaasicHeader, BaasicInput, BaasicTextArea, BaasicDropdown, AddressAutofill } from 'core/components';
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';
import SelectSkuQuantityTemplate from './SelectSkuQuantityTemplate';

const ReturnLabelTemplate = ({
	t,
	returnLabelViewStore,
	returnLabelViewStore: {
		form,
		isFormValid,
		loading,
		isCarrierServiceLoading,
		rootStore,
		selectedOrder,
		boxForm,
		isBoxRequired,
		noRatesMessage,
		onePerBoxMessage,
		returnAddressDropDownStore,
		onAddressDataChange,
		addressAutofillViewStore,
		openAddReturnAddressModal,
		returnReasonDropdownStore,
		carrierServiceDropdownStore,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<React.Fragment>
			<div className="order">
				<BaasicHeader title="Return Label" rootStore={rootStore}></BaasicHeader>
				<div className="container container--lrg container--footer">
					<div>
						<SelectSkuQuantityTemplate
							t={t}
							viewStore={returnLabelViewStore}
							additionalDisableCheck={isCarrierServiceLoading}
							productsForSelection={selectedOrder.orderLines}
							onePerBoxInputDisable={true}
							title={'ORDERVIEW.RETURNLABELVIEW.SELECTITEMS'}
							warningMessage={onePerBoxMessage}
						/>

						{/* Box Dropdown */}
						{isBoxRequired && <BoxSelection returnLabelViewStore={returnLabelViewStore} t={t} />}

						<form onSubmit={form.onSubmit}>
							{(isBoxRequired ? boxForm.$('boxId').value && boxForm.$('boxId').value.label !== 'Add new template' : true) &&
								selectedOrder.orderLines.some(i => i.isChecked || i.isPartiallyChecked) && (
									<React.Fragment>
										<div className="spc--bottom--med"></div>
										<div className="row row--form">
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput
													field={form.$('buyerName')}
													className="fs-mask"
													onKeyUp={() => onAddressDataChange()}
												/>
											</div>
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput field={form.$('phone1')} onKeyUp={() => onAddressDataChange()} />
											</div>
											<div className="col col-sml-12 col-lrg-6">
												<AddressAutofill viewStore={addressAutofillViewStore} t={t} />
											</div>
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput field={form.$('address2')} />
											</div>
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput field={form.$('address3')} />
											</div>
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput field={form.$('city')} onKeyUp={() => onAddressDataChange()} />
											</div>
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput field={form.$('zipCode')} onKeyUp={() => onAddressDataChange()} />
											</div>
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput field={form.$('countryStateCode')} onKeyUp={() => onAddressDataChange()} />
											</div>
											<div className="col col-sml-12 col-lrg-6">
												<BaasicInput field={form.$('countryCode')} onKeyUp={() => onAddressDataChange()} />
											</div>
											<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
												<BaasicDropdown dropdownStore={returnReasonDropdownStore} />
											</div>
											<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
												<div className="row row--form">
													<div className="col col-sml-12 col-lrg-8">
														<BaasicDropdown dropdownStore={returnAddressDropDownStore} />
													</div>
													<div className="col col-sml-12 col-lrg-4">
														<button
															className="btn btn--med btn--primary"
															onClick={openAddReturnAddressModal}
															type="button"
														>
															<i className="fa fa-plus spc--right--sml"></i>
															{t('RETURNADDRESSVIEW.ADDRETURNADDRESS')}
														</button>
													</div>
												</div>
											</div>
											<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
												<BaasicDropdown
													dropdownStore={carrierServiceDropdownStore}
													isDisabled={isCarrierServiceLoading || !form.isValid}
												/>
											</div>
											{noRatesMessage && (
												<React.Fragment>
													<div className="col col-sml-12 col-lrg-6"></div>
													<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
														<p className="type--color--warning">{t(noRatesMessage)}</p>{' '}
													</div>
												</React.Fragment>
											)}
											<div className="col col-sml-12">
												<BaasicTextArea field={form.$('internalNote')} />
											</div>
										</div>
									</React.Fragment>
								)}
							<div className="container__footer type--right">
								<button
									className="btn btn--med btn--success spc--right--sml spc--bottom--sml"
									type="submit"
									disabled={
										loading ||
										!isFormValid ||
										isCarrierServiceLoading ||
										!selectedOrder.orderLines.some(i => i.isChecked || i.isPartiallyChecked) ||
										noRatesMessage
									}
								>
									{loading && !isCarrierServiceLoading ? (
										<div className="spinnercont spc--right--sml">
											<div className="spinner"></div>
										</div>
									) : null}
									{t('ORDERVIEW.RETURNLABELVIEW.CREATE')}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
			<ReactTooltip />
		</React.Fragment>
	);
};

export default defaultTemplate(ReturnLabelTemplate);

const BoxSelection = observer(
	({
		t,
		returnLabelViewStore: {
			showCreateTemplate,
			onCreateTemplateCancel,
			boxForm,
			isBoxRequired,
			boxDropdownStore,
			addNewTemplateOptionOverride,
		},
	}) => {
		return (
			<div>
				<div className="row">
					<div className="col col-sml-12 col-med-6 spc--bottom--med">
						<BaasicDropdown
							dropdownStore={boxDropdownStore}
							isDisabled={!isBoxRequired}
							isClearable={true}
							className="flex--grow--1"
							placeholder={isBoxRequired ? undefined : t('ORDERVIEW.RETURNLABELVIEW.BOXNOTREQUIRED')}
							optionOverride={addNewTemplateOptionOverride}
						/>
					</div>
				</div>

				{showCreateTemplate && (
					<form className="box--primary box--sml" onSubmit={boxForm.onSubmit}>
						<div className="box__header">
							<h4 className="type--base type--color--grey-5">
								{t('ORDERVIEW.RETURNLABELVIEW.BOX.CREATEDIMENSIONSTEMPLATE')}
							</h4>
						</div>
						<div className="row row--form">
							<div className="col col-sml-12 col-med-6 col-lrg-3">
								<BaasicInput field={boxForm.$('name')} placeholder={t('ORDERVIEW.RETURNLABELVIEW.BOX.NAME')} />
							</div>
							<div className="col col-sml-12 col-med-6 col-lrg-3">
								<BaasicInput field={boxForm.$('height')} placeholder={t('ORDERVIEW.RETURNLABELVIEW.BOX.HEIGHT')} />
							</div>
							<div className="col col-sml-12 col-med-6 col-lrg-3">
								<BaasicInput field={boxForm.$('width')} placeholder={t('ORDERVIEW.RETURNLABELVIEW.BOX.WIDTH')} />
							</div>
							<div className="col col-sml-12 col-med-6 col-lrg-3">
								<BaasicInput field={boxForm.$('length')} placeholder={t('ORDERVIEW.RETURNLABELVIEW.BOX.LENGTH')} />
							</div>
						</div>
						<div>
							<button className="btn btn--sml btn--primary spc--right--sml" type="submit">
								{t('ORDERVIEW.RETURNLABELVIEW.BOX.CREATE')}
							</button>
							<button className="btn btn--sml btn--outline" type="button" onClick={() => onCreateTemplateCancel()}>
								{t('ORDERVIEW.RETURNLABELVIEW.BOX.CANCEL')}
							</button>
						</div>
					</form>
				)}
			</div>
		);
	}
);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/ReturnLabelTemplate.jsx